import { Box } from 'approot/shared/design-system/box/box.style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import {
  NotificationContent,
  NotificationTip,
  NotificationTipText,
} from 'approot/shared/notifications/notification-tip.style';
import { purple1 } from 'approot/shared/styles/colours.style';
import { AnchorStyled } from 'approot/shared/styles/typography.style';
import CodeForSchoolsLogo from './cs-for-schools-logo';

export const CS_FOR_SCHOOLS_LINK = 'https://csinschools.io';

export const CsInSchoolsLogo = ({
  justifyContent,
}: {
  justifyContent?:
    | 'center'
    | 'flex-end'
    | 'flex-start'
    | 'space-between'
    | 'space-evenly';
}) => (
  <Box $justifyContent={justifyContent} $marginTop={spacing16}>
    <CodeForSchoolsLogo width={122} height={47} />
  </Box>
);

export const CsInSchoolsLink = () => (
  <AnchorStyled
    href={CS_FOR_SCHOOLS_LINK}
    target="_blank"
    rel="noopener noreferrer"
  >
    Code for Schools
  </AnchorStyled>
);

export const CsInSchoolsBanner = () => {
  return (
    <NotificationTip $colour={purple1} $marginBottom={20}>
      <NotificationContent>
        <NotificationTipText marginBottom={4}>
          Created in partnership with <CsInSchoolsLink />
        </NotificationTipText>
        <CsInSchoolsLogo />
      </NotificationContent>
    </NotificationTip>
  );
};
